import styled from 'styled-components';
import { getBackgroundColor, themeGet } from '@magalu/stereo-ui-styles';
import Input from '../../atoms/Input';
import Flex from '../../atoms/Flex';
import Button from '../../atoms/Button';
export const CouponCodeContainer = styled(Flex).attrs(props => Object.assign({}, props, {
  alignItems: 'center'
}))`
  background-color: ${getBackgroundColor('limeGreen')};
  border-radius: 8px;
  height: 40px;
  padding: 6px;
  width: 100%;
  margin-bottom: 12px;
`;
export const CouponCodeLabel = styled(Flex).attrs(props => Object.assign({
  alignItems: 'center'
}, props))`
  color: ${props => themeGet('colors.black')(props)};
  flex-shrink: 0;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  padding: 0 6px;
  width: fit-content;

  > strong {
    font-weight: 600;
  }

  > svg {
    margin-right: 4px;
  }
`;
export const CouponCodeInputWrapper = styled(Flex)`
  width: 100%;
  position: relative;
`;
export const CouponCodeInput = styled(Input)`
  border: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  color: ${props => themeGet('colors.darkGray')(props)};
  font-weight: 600;
  height: 28px;
`;
export const CouponCodeButton = styled(Button).attrs(props => Object.assign({
  uppercase: false
}, props))`
  align-items: center;
  background-color: ${getBackgroundColor('white')};
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  color: ${props => themeGet('colors.blue')(props)};
  display: flex;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: 600;
  height: 28px;
  min-width: 74px;
  padding: ${props => themeGet('space.1')(props)}px;

  svg {
    margin-right: 4px;
    fill: ${props => themeGet('colors.blue')(props)};
  }

  &:hover {
    color: ${props => themeGet('colors.blue')(props)};
    background-color: ${getBackgroundColor('white')};
  }
`;
export const CouponCodeCopied = styled.div`
  align-items: center;
  background-color: ${props => themeGet('colors.deepGreen')(props)};
  border-radius: 4px;
  color: ${props => themeGet('colors.white')(props)};
  display: flex;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: 600;
  height: 28px;
  justify-content: center;
  opacity: ${({
  isActive
}) => isActive ? 1 : 0};
  pointer-events: ${({
  isActive
}) => isActive ? 'auto' : 'none'};
  position: absolute;
  transition: opacity 0.2s ease-in;
  width: 100%;
  > svg {
    fill: ${props => themeGet('colors.white')(props)};
    margin-right: 4px;
  }
`;
export const CouponCodeAuxiliaryText = styled.div`
  color: ${props => themeGet('colors.greyishBrown')(props)};
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
`;